module.exports = __webpack_public_path__ + "static/media/canteen.e2fc4b77.jpg";